import { render, staticRenderFns } from "./Hola.vue?vue&type=template&id=68efe708&"
import script from "./Hola.vue?vue&type=script&lang=js&"
export * from "./Hola.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports